<template>
  <LearningForm />
</template>

<script>
import LearningForm from './LearningForm.vue'

export default {
  components: {
    LearningForm,
  },
}
</script>
